(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)})};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-depth"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const arm = (root) => {
      if (root.dataset.fmDepthArmed === '1') return;
      const rows = [...root.querySelectorAll('.fm-dp__row')];
      if (!rows.length) return;
      root.dataset.fmDepthArmed = '1';

      if (reduce) {
        rows.forEach((row) => row.classList.add('is-lit'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-lit', entry.isIntersecting);
          });
        },
        { rootMargin: '-32% 0px -32% 0px', threshold: 0 }
      );
      rows.forEach((row) => observer.observe(row));
    };

    const armAll = () => document.querySelectorAll('.fm-dp').forEach(arm);

    armAll();
    document.addEventListener('shopify:section:load', armAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-dial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.fmDialArmed === '1') return;
      const needle = root.querySelector('.fm-dl__needle');
      const thumbs = [...root.querySelectorAll('.fm-dl__thumb')];
      const panels = [...root.querySelectorAll('.fm-dl__panel')];
      const spin = root.querySelector('.fm-dl__spin');
      if (!needle || thumbs.length < 2) return;
      root.dataset.fmDialArmed = '1';

      const angles = thumbs.map((_, i) => (360 / thumbs.length) * i);
      let rot = angles[0] || 0;

      const show = (index, animate) => {
        const target = angles[index];
        if (animate) {
          const current = ((rot % 360) + 360) % 360;
          rot = rot - current + target + 1080;
        } else {
          rot = target;
        }
        needle.style.transform = 'translate(-50%, -50%) rotate(' + rot + 'deg)';
        thumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
        panels.forEach((el, i) => el.classList.toggle('is-active', i === index));
      };

      thumbs.forEach((el, i) => {
        el.addEventListener('click', () => show(i, true));
      });

      if (spin) {
        spin.addEventListener('click', () => {
          const active = thumbs.findIndex((el) => el.classList.contains('is-active'));
          let next = active;
          while (next === active) next = Math.floor(Math.random() * thumbs.length);
          show(next, true);
        });
      }

      show(0, false);
    };

    const initAll = () => document.querySelectorAll('.fm-dl').forEach(init);

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
